import { useState, useRef, useEffect } from "react";
import SwitchToggle from "./switch";
import infoCircle from "../assets/info-circle.svg";
import dots from "../assets/verticle-dots.svg";
import defaulticon from "../assets/CheckCircle.svg";
import edit from "../assets/edit.svg";
import trash from "../assets/red-trash.svg";
import add from "../assets/plus-blue.svg";
import { AddNewRegion, deletePage, fetchLanguageList, fetchRegionList, UpdateActiveInactiveStatus } from "../action/page";
import CommonModal from "./CommonModal";
import { useNavigate } from "react-router-dom";
import cross from "../assets/black-cross.svg";
import inputbadge from "../assets/pen1.svg";
import { useToast } from "./ToastProvider";

const RegionSpecific = ({ pageId, pageData, setPageData }) => {

  const navigate = useNavigate();
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [loadingLists, setLoadingLists] = useState(false);

  const [showRegionModal, setShowRegionModal] = useState(false);

  const [regions, setRegions] = useState([]);
  const [languages, setLanguages] = useState([]);
  const { showToast } = useToast();
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");

  // Fetch lists
  const loadLists = async () => {
    setLoadingLists(true);
    const r = await fetchRegionList();
    const l = await fetchLanguageList();
    setRegions(r?.data?.list || []);
    setLanguages(l?.data?.list || []);
    setLoadingLists(false);
  };
  const handleDeletePageVersion = async (versionId) => {
    if (!window.confirm("Are you sure you want to delete this version?")) return;

    try {
      const res = await deletePage(versionId);

      if (res?.status) {
        showToast("Version deleted successfully", "success");

        // Remove deleted version from UI
        setPageData((prev) => ({
          ...prev,
          all_pages: prev.all_pages.filter((p) => p._id !== versionId)
        }));

        setOpenDropdownIndex(null);
      } else {
        showToast(res?.message || "Failed to delete version", "error");
      }
    } catch (err) {
      showToast("Delete failed", "error");
    }
  };



  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdownIndex(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // -------------------------------------
  // ❌ Cannot put hooks above inside this!
  // ✔ Safe to return early AFTER hooks
  // -------------------------------------
  if (!pageId) return null;

  // Default language shown on edit page
  const displayedLanguage = pageData?.language?.name || "English";
  const handleToggleStatus = async (versionId, currentStatus) => {
    try {
      const newStatus = currentStatus === "published" ? "in-active" : "published";

      const res = await UpdateActiveInactiveStatus(versionId, { status: newStatus });

      if (res?.status) {
        showToast(`Status updated to ${newStatus}`, "success");

        setPageData((prev) => ({
          ...prev,
          all_pages: prev.all_pages.map((p) =>
            p._id === versionId ? { ...p, status: newStatus } : p
          )
        }));

        setOpenDropdownIndex(null);
      } else {
        showToast(res?.message || "Failed to update status", "error");
      }
    } catch (err) {
      showToast("Update failed", "error");
    }
  };

  return (
    <>
      {/* MAIN CARD */}
      <div className="theme-card p-4 mb-3">
        <div className="card-title pb-1 d_flex">
          Region Specific Content
          {/* <SwitchToggle checked={true} disabled={true} /> */}
        </div>

        <label className="frm-label d-flex align-items-center">
          Manage localized versions of this page.
          <img className="ms-2" src={infoCircle} alt="Info" title="Manage localized versions of this page." />
        </label>

        {/* Default Language Field */}
        {pageData?.all_pages?.map((l, index) => {
          const isEditingThisPage = pageId === l._id;
          return (
            <div
              key={index}
              className="coutry-fields"
              style={{ position: "relative" }}
            >
              <div className="input-with-icon right mt-3">
                {isEditingThisPage && (
                  <div className="input_badge">
                    <img src={inputbadge} alt="icon" />
                    <span className="field-label">Editing Page</span>
                  </div>
                )}

                <input
                  type="text"
                  className="frm-input"
                  value={l.locale}
                  readOnly
                  onClick={(e) => {
                    e.stopPropagation();   // prevent navigation
                  }}
                />

                <img
                  src={dots}
                  className="input-icon pointer"
                  alt="dots"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
                  }}
                />
              </div>

              {!isEditingThisPage && openDropdownIndex === index && (
                <div className="region-dropdown-menu" ref={dropdownRef}>
                  {/* <div className="dropdown-item">
                    <img src={defaulticon} alt="icon" /> Mark as Default Page
                  </div> */}
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setOpenDropdownIndex(null); 
                      navigate(`/pages/${l._id}`, {
                        state: { locale: l.locale },  // pass locale
                      });
                    }}
                  >
                    <img src={edit} alt="icon" /> Edit Regional Content
                  </div>
{/*                  
                  {(l.region || l.language) && (
                    <div
                      className="dropdown-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleStatus(l._id, l.status);
                      }}
                    >
                      <img src={edit} alt="icon" />
                      {l.status === "published" ? "Make Inactive" : "Make Active"}
                    </div>
                  )} */}

                  {/* SHOW DELETE ONLY IF THIS IS NOT THE DEFAULT VERSION */}
                  {(l.region || l.language) && (
                    <div
                      className="dropdown-item delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleDeletePageVersion(l._id);
                      }}
                    >
                      <img src={trash} alt="icon" /> Delete Page Version
                    </div>
                  )}


                </div>
              )}
            </div>
          )
        })}

        {/* Add New Region */}
        <div className="addmore pt-3">
          <button
            type="button"
            className="add-blue-link"
            onClick={() => {
              loadLists();
              setShowRegionModal(true);
            }}
          >
            <img alt="add" src={add} /> Add New Region
          </button>
        </div>
      </div>

      {/* REGION MODAL */}
      {showRegionModal && (
        <CommonModal
          show={showRegionModal}
          onClose={() => setShowRegionModal(false)}
          width="500px"
          height="auto"
        >
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
            Select Region for Content <img src={cross} alt="icon" className="pointer" onClick={() => setShowRegionModal(false)}
 />
          </div>
       
          <p className="modal-subtitle">
            Choose the region you want to create localized content for. Visitors from the selected region will see this version.
          </p>

          {/* Region */}
          <label className="frm-label">Select Region</label>
          <select
            className="frm-input"
            value={selectedRegion}
            disabled={loadingLists} 
            onChange={(e) => setSelectedRegion(e.target.value)}
          >
            {loadingLists ? (
              <option>Loading regions...</option>
            ) : (
              <>
                <option value="">Choose region</option>
                {regions.map((r) => (
                  <option key={r._id} value={r._id}>
                    {r.name}
                  </option>
                ))}
              </>
            )}
          </select>

          {/* Language */}
          <label className="frm-label mt-3">Select Language</label>
          <select
            className="frm-input"
            value={selectedLanguage}
            disabled={loadingLists}
            onChange={(e) => setSelectedLanguage(e.target.value)}
          >
            {loadingLists ? (
              <option>Loading languages...</option>
            ) : (
              <>
                <option value="">Choose language</option>
                {languages.map((l) => (
                  <option key={l._id} value={l._id}>
                    {l.name}
                  </option>
                ))}
              </>
            )}
          </select>

          {/* Footer Buttons */}
          <div className="modal-actions mt-4">
            <button
              className="btn-white"
              onClick={() => setShowRegionModal(false)}
            >
              Cancel
            </button>

            {/* <button
                className="btn-black"
                onClick={() => {
                  if (!selectedRegion || !selectedLanguage) return;

                  console.log("CONFIRMED NEW REGION =", {
                    region_id: selectedRegion,
                    language_id: selectedLanguage,
                  });

                  setShowRegionModal(false);
                }}
              >
                Confirm
              </button> */}
            <button
              className="btn-black"
              onClick={async () => {
                if (!selectedRegion || !selectedLanguage) return;

                const regionObj = regions.find((r) => r._id === selectedRegion);
                const langObj = languages.find((l) => l._id === selectedLanguage);

                if (!regionObj || !langObj) return;

                const locale = `${regionObj.code}-${langObj.slug}`;

                const trueParentId = pageData?.parent_id || pageId;

                const res = await AddNewRegion({
                  locale,
                  parent_id: trueParentId
                });

                if (res?.data?.status === 1) {
                  showToast("Region added successfully", "success");

                  // 2️⃣ Add new version to UI list
                  setPageData((prev) => ({
                    ...prev,
                    all_pages: [
                      ...prev.all_pages,
                      {
                        _id: res.data.data._id,
                        locale: res.data.data.locale,
                        region: regionObj,
                        language: langObj
                      }
                    ]
                  }));


                  setShowRegionModal(false);
                  return;
                }

                // Handle error
                showToast(res?.message || "Failed to add region", "error");
              }}
            >
              Confirm
            </button>

          </div>
        </CommonModal>
      )}
    </>
  );
};

export default RegionSpecific;
